export const environment = {
  production: true,
  apiURL: '/rest',
  ssoEnabled: true
};

